module.exports = __webpack_public_path__ + "img/Data.a2e3cbed.svg";